/**
 * Throttle (троттлинг) — это техника, которая ограничивает количество вызовов функции
 * в определенный промежуток времени. В отличие от дебаунса, функция будет вызываться
 * с фиксированным интервалом, даже если события происходят чаще.
 * Это полезно, когда вы хотите, чтобы функция выполнялась регулярно, но не слишком часто.
 */
export const throttle = (func, delay) => {
    let timeout = false;
    return (...args) => {
        if (!timeout) {
            func.apply(this, args);
            timeout = true;
            setTimeout(() => {
                timeout = false;
            }, delay);
        }
    };
};
// Вариант throttle, который не упускает последнее срабатывание события
export const throttleComplete = (func, delay) => {
    let lastFunc;
    let lastRan;
    return (...args) => {
        if (!lastRan) {
            func.apply(this, args);
            lastRan = Date.now();
        }
        else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if (lastRan !== undefined && Date.now() - lastRan >= delay) {
                    func.apply(this, args);
                    lastRan = Date.now();
                }
            }, delay - (Date.now() - lastRan));
        }
    };
};
// Пример использования:
// throttleBtn.addEventListener('click', throttle(function() {
//   return console.log('Hey! It is', new Date().toUTCString());
// }, 1000));
// или
// window.addEventListener("scroll", throttle(handleScrollPage, 100));
// JavaScript варианты:
// export const throttle = (func, delay) => {
//   let timeout;
//   return (...args) => {
//     const context = this;
//     if (!timeout) {
//       func.apply(context, args);
//       timeout = true;
//       setTimeout(() => timeout = false, delay);
//     }
//   };
// };
// export const throttleComplete = (func, delay) => {
//   let lastFunc;
//   let lastRan;
//   return (...args) => {
//     const context = this;
//     if (!lastRan) {
//       func.apply(context, args);
//       lastRan = Date.now();
//     } else {
//       clearTimeout(lastFunc);
//       lastFunc = setTimeout(() => {
//         if ((Date.now() - lastRan) >= delay) {
//           func.apply(context, args);
//           lastRan = Date.now();
//         }
//       }, delay - (Date.now() - lastRan));
//     }
//   };
// };
